import '../node_modules/semantic-ui-css/semantic.min.css';
import './styles/base.css';


import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {Container} from 'semantic-ui-react';
import NavigationView from './containers/NavigationView';
import HomeView from './containers/HomeView';
import ProductsView from './containers/ProductsView';
import PortfolioView from './containers/PortfolioView';
import TestimonialsView from './containers/TestimonialsView';
import SupportView from './containers/SupportView';
import UnderDevView from './containers/UnderDevView';
import NotFoundView from './containers/NotFoundView';
import AboutView from './containers/AboutView';
import ServicesView from './containers/ServicesView';
import BlogView from './containers/BlogView';
import ArticleView from './containers/ArticleView';

ReactDOM.render(
  <Router>
  <Container fluid textAlign="center">
    <NavigationView/>
    <Switch>
      <Route exact path="/" component={HomeView}/>
      <Route exact path="/about" component={AboutView}/>
      <Route exact path="/products" component={ProductsView}/>
      <Route exact path="/services" component={ServicesView}/>
      <Route exact path="/portfolio" component={PortfolioView}/>
      <Route exact path="/testimonials" component={TestimonialsView}/>
      <Route exact path="/support" component={SupportView}/>
      <Route path="/blog/:articleId" component={ArticleView}/>
      <Route exact path="/blog" component={BlogView}/>
      
      <Route component={NotFoundView}/>
    </Switch>
  </Container>
</Router>, document.getElementById('app'));



// WEBPACK FOOTER //
// ./client/index.js